import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import DashboardCards from "./DashboardCards";
import MotionWrapper from "../../../components/MotionWrapper";
import { useSelector } from "react-redux";

export default function RightDrawer({
  data,
  state,
  setState,
  setSelected,
  selected,
}) {
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ right: open });
  };
  const handleClick = (e, item) => {
    setSelected((prev) => (prev?.project_id === item.project_id ? prev : item));
    setState((prev) => (prev.right ? { ...prev, right: false } : prev));
  };
  const { finDashData, loading } = useSelector((state) => state.finance);

  return (
    <div>
      <Drawer anchor="right" open={state.right} onClose={toggleDrawer(false)}>
        <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
          <Button
            size="small"
            onClick={() => {
              setState({ right: false });
            }}
            sx={{ borderRadius: 4 }}
            variant="outlined"
          >
            X
          </Button>
        </Box>
        <Box p={3} sx={{ minWidth: 250 }} maxWidth={300}>
          <Grid
            container
            spacing={{ xs: 2, md: 3 }}
            columns={{ xs: 4, sm: 8, md: 12 }}
          >
            {finDashData?.map((item) => (
              <Grid item xs={12} sm={12} md={12} key={item.project_id}>
                <MotionWrapper directions={"right"} delay={0.5}>
                  <DashboardCards
                    handleClick={(e) => handleClick(e, item)}
                    data={item}
                    selected={selected}
                  />
                </MotionWrapper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Drawer>
    </div>
  );
}
